<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="700"
        :fullscreen="isMobile" persistent @keydown.esc="chiudi">
        <v-card v-if="scadenza">
            <v-card-title class="d-flex align-center">
                <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                <div>
                    <div>Completa scadenza</div>
                    <div class="text-caption text-medium-emphasis font-weight-regular">
                        {{ scadenza.mezzoNome }} — {{ scadenza.tipoScadenzaMezzoNome }}
                    </div>
                </div>
            </v-card-title>

            <v-card-text>
                <v-alert v-if="errore" type="error" variant="tonal" density="comfortable" class="rounded-lg mb-3"
                    closable @click:close="errore = null">
                    {{ errore }}
                </v-alert>

                <div class="text-subtitle-2 font-weight-medium mb-2">Foto</div>
                <v-file-input v-model="fileSelezionato" label="Carica foto" accept="image/*" density="compact"
                    variant="outlined" prepend-icon="mdi-camera" @update:model-value="caricaFoto" />
                <v-row v-if="scadenza.foto && scadenza.foto.length" dense>
                    <v-col v-for="f in scadenza.foto" :key="f.id" cols="6" sm="4">
                        <v-card variant="outlined" class="rounded-lg pa-2 d-flex align-center">
                            <v-icon size="small" class="mr-1">mdi-image</v-icon>
                            <span class="text-caption text-truncate">{{ f.nomeOriginale }}</span>
                        </v-card>
                    </v-col>
                </v-row>

                <v-divider class="my-3" />

                <v-text-field v-model="dataEsecuzione" type="date" label="Data di esecuzione" :max="oggiIso"
                    variant="outlined" density="comfortable"
                    hint="Se l'hai eseguita in un altro giorno, indicalo qui: la prossima scadenza si calcola da questa data"
                    persistent-hint class="mb-3" />

                <v-textarea v-model="note" label="Note di completamento" rows="3" variant="outlined" />

                <v-alert v-if="scadenza.ricorrente" type="info" variant="tonal" density="comfortable"
                    class="rounded-lg">
                    <div class="font-weight-medium">Pianificazione ricorrente</div>
                    <div class="text-body-2">
                        Verrà generata una nuova occorrenza in fondo alla serie, mantenendo pieno l'orizzonte
                        di anni configurato per l'azienda.
                    </div>
                </v-alert>
                <v-alert v-else-if="prossimaDataPreview" type="info" variant="tonal" density="comfortable"
                    class="rounded-lg">
                    <div class="font-weight-medium">Prossima scadenza pianificata</div>
                    <div class="text-body-2">
                        Frequenza del tipo "{{ scadenza.tipoScadenzaMezzoNome }}": prossima scadenza prevista
                        <strong>{{ formattaData(prossimaDataPreview) }}</strong>.
                    </div>
                </v-alert>
                <div v-else class="text-caption text-medium-emphasis">
                    Questo tipo di scadenza non ha una frequenza configurata: non verrà generata automaticamente
                    una prossima occorrenza.
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="success" :loading="salvataggio" @click="completa">Completa scadenza</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { upload_allegato_scadenzaMezzo } from "@/api/api.allegati.js";

export default {
    name: "DialogCompletaScadenzaMezzo",

    props: {
        modelValue: { type: Boolean, default: false },
        scadenzaMezzoId: { type: [Number, String], default: null },
        mezzoId: { type: [Number, String], required: true },
    },
    emits: ["update:modelValue", "completata"],

    data() {
        return {
            salvataggio: false,
            note: "",
            dataEsecuzione: "",
            fileSelezionato: null,
            errore: null,
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        oggiIso() {
            return this.toIsoLocale(new Date());
        },
        scadenza() {
            return this.$store.getters["scadenzeMezzo/corrente"];
        },
        tipoCorrente() {
            if (!this.scadenza) return null;
            const lista = this.$store.getters["tipiScadenzaMezzo/lista"];
            return lista.find(t => t.id === this.scadenza.tipoScadenzaMezzoId) || null;
        },
        prossimaDataPreview() {
            if (!this.tipoCorrente) return null;
            return this.calcolaProssimaData(
                this.dataEsecuzione || this.oggiIso,
                this.tipoCorrente.frequenzaValore,
                this.tipoCorrente.frequenzaUnita
            );
        },
    },

    watch: {
        async modelValue(val) {
            if (val && this.scadenzaMezzoId) {
                this.note = "";
                this.dataEsecuzione = this.oggiIso;
                this.fileSelezionato = null;
                this.errore = null;
                this.$store.dispatch("tipiScadenzaMezzo/carica");
                await this.$store.dispatch("scadenzeMezzo/caricaDettaglio", this.scadenzaMezzoId);
            }
        },
    },

    methods: {
        formattaData(iso) {
            if (!iso) return "";
            return new Date(iso + "T00:00:00").toLocaleDateString("it-IT", {
                day: "numeric", month: "long", year: "numeric",
            });
        },

        calcolaProssimaData(dataIso, frequenzaValore, frequenzaUnita) {
            if (!frequenzaValore || !frequenzaUnita) return null;
            const d = new Date(dataIso + "T00:00:00");
            switch (frequenzaUnita) {
                case "Giorni": d.setDate(d.getDate() + frequenzaValore); break;
                case "Settimane": d.setDate(d.getDate() + frequenzaValore * 7); break;
                case "Mesi": d.setMonth(d.getMonth() + frequenzaValore); break;
                case "Anni": d.setFullYear(d.getFullYear() + frequenzaValore); break;
                default: return null;
            }
            return this.toIsoLocale(d);
        },

        toIsoLocale(d) {
            const y = d.getFullYear();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const g = String(d.getDate()).padStart(2, "0");
            return `${y}-${m}-${g}`;
        },

        async caricaFoto(file) {
            if (!file) return;
            try {
                await upload_allegato_scadenzaMezzo(this.scadenzaMezzoId, file);
                await this.$store.dispatch("scadenzeMezzo/caricaDettaglio", this.scadenzaMezzoId);
                this.fileSelezionato = null;
            } catch (error) {
                console.log(error);
            }
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },

        async completa() {
            this.salvataggio = true;
            this.errore = null;
            try {
                await this.$store.dispatch("scadenzeMezzo/completa", {
                    id: this.scadenzaMezzoId,
                    mezzoId: this.mezzoId,
                    dati: {
                        noteCompletamento: this.note,
                        dataEsecuzione: this.dataEsecuzione || null,
                    },
                });
                this.$emit("completata");
                this.chiudi();
            } catch (error) {
                console.log(error);
                this.errore = (error.response && error.response.data && error.response.data.message)
                    || "Non è stato possibile completare la scadenza. Riprova.";
            }
            this.salvataggio = false;
        },
    },
};
</script>
